import React, {Fragment, useContext, useEffect, useState} from 'react';
import './GuestOrderPopup.less';
import {DrawerPopup} from "../../dialog-layout/drawer-popup/DrawerPopup";
import {
    getBrowserFullLocale,
    getPhoneCodeForFullLocale,
    getSafeTranslation
} from "../../../helpers/localization.helper";
import {TranslationsContext} from "../../../contexts/translations-context";
import {Button} from "../../elements/button/Button";
import {Input} from "../../elements/input/Input";
import {Select} from "elements/select/Select";
import {Consent} from "compositions/consent/Consent";
import {ConsentText} from "elements/consent-text/ConsentText";
import {Link} from "elements/link/Link";
import {ErrorCard} from "elements/error-card/ErrorCard";

function getCodeFromPhone(phoneCodes, phone) {
    return phoneCodes.find(phoneCode => new RegExp('^' + phoneCode.value.replace('+', '\\+')).test(phone));
}

export const GuestOrderPopup = (
    {
        currentRestaurant,
        error,
        isRequestInProgress,
        phoneCodes,
        onContinueAsGuest,
        onCancel,
        onLogin,
        onSignup
    }
) => {
    const defaultPhoneCode = getPhoneCodeForFullLocale(
        phoneCodes,
        getBrowserFullLocale()
    );
    const translations = useContext(TranslationsContext);
    const [name, setName] = useState('');
    const [code, setCode] = useState(defaultPhoneCode.value)
    const [phone, setPhone] = useState(defaultPhoneCode.value);
    const [termsConsent, setTermsConsent] = useState(true);
    const [errorArray, setErrorArray] = useState([]);

    useEffect(() => {
        setErrorArray(error?.split(';') ?? []);
    }, [error]);

    const selectChanged = (newCode) => {
        setPhone(newCode + phone.replace(code, ''))
        setCode(newCode);
        setTimeout(() => {
            document.getElementById('phone-number-input').focus();
        }, 200);
    }

    return (
        <DrawerPopup
            title={
                getSafeTranslation('GuestOrderPopup.title', translations)
            }
            onOverlayClick={onCancel}
            leftControl={<Button
                isText
                onClick={onCancel}
            >
                {getSafeTranslation('GuestOrderPopup.cancelButtonCaption', translations)}
            </Button>}
            rightControl={<Button
                isAutoWidth
                onClick={() => onContinueAsGuest(name, phone, termsConsent)}
            >
                {getSafeTranslation('GuestOrderPopup.doneButtonCaption', translations)}
            </Button>}
        >
            <div className="guest-order-popup">
                <div className="guest-card">
                    <div className="guest-card__title">
                        {getSafeTranslation('GuestOrderPopup.guestCardTitle', translations)}
                    </div>
                    {
                        error && (<div className='guest-card-error-list'>
                            {
                                errorArray.map((err, index) => {
                                    return <ErrorCard errorKey={err} key={index}/>
                                })
                            }
                        </div>)
                    }
                    <div className="guest-card__form">
                        <div className="guest-card__form-input">
                            <div className="guest-card__form-input__label">
                                {getSafeTranslation('GuestOrderPopup.guestCardNameLabel', translations)}
                            </div>
                            <Input value={name} onChange={setName} focusOnMount/>
                            <div className="guest-card__form-input__helper">
                                {getSafeTranslation('GuestOrderPopup.guestCardNameLabelDescription', translations)}
                            </div>
                        </div>
                        <div className="guest-card__form-input">
                            <div className="guest-card__form-input__label">
                                {getSafeTranslation('GuestOrderPopup.guestCardPhoneLabel', translations)}
                            </div>
                            <div className="phone">
                                <div className="phone__input-container">
                                    <div className="phone__code">
                                        <Select
                                            items={phoneCodes.map(phoneCode => ({
                                                id: phoneCode.value,
                                                name: phoneCode.description
                                            }))}
                                            selectedItemId={code}
                                            onChange={selectChanged}
                                            key={code}
                                        />
                                    </div>
                                    <div className="phone__number">
                                        <Input
                                            value={phone}
                                            inputMode="tel"
                                            regex={/^[\+\d\s]*$/}
                                            onChange={newPhone => {
                                                setPhone(newPhone);
                                                setCode(getCodeFromPhone(phoneCodes, newPhone).value);
                                            }}
                                            id={'phone-number-input'}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="guest-card__form-input__helper">
                                {getSafeTranslation('GuestOrderPopup.guestCardPhoneLabelDescription', translations)}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="terms">
                    <div className="terms__terms-consent" onClick={() => setTermsConsent(!termsConsent)}>
                        <Consent
                            isChecked={termsConsent}
                            caption={
                                <Fragment>
                                    <ConsentText
                                        text={getSafeTranslation('GuestOrderPopup.termsConsentCheckboxCaption', translations)}/>
                                    <Link>
                                        {getSafeTranslation('GuestOrderPopup.termsLinkCaption', translations)}
                                    </Link>
                                </Fragment>

                            }
                        />
                    </div>
                </div>
                <div className="separator">{getSafeTranslation('GuestOrderPopup.or', translations)}</div>
                <div className="regular-customer-card">
                    <div className="regular-customer-card__title">
                        {getSafeTranslation('GuestOrderPopup.customerCardTitle', translations)}
                    </div>
                    <div className="regular-customer-card__description">
                        {getSafeTranslation('GuestOrderPopup.customerCardDescription', translations)}
                    </div>
                    <div className="regular-customer-card__action">
                        <Button onClick={() => onLogin(phone)}>{getSafeTranslation('GuestOrderPopup.login', translations)}</Button>
                        <Button onClick={onSignup}>{getSafeTranslation('GuestOrderPopup.signup', translations)}</Button>
                    </div>
                </div>

            </div>
        </DrawerPopup>
    );
}
